<template>
  <div>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          sm="10"
          md="10"
          lg="10"
          class="d-flex flex-wrap"
        >
          <v-row
            v-if="exibirChips"
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-tooltip
                v-for="chip in appliedFilters"
                :key="chip.label"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    class="ma-1"
                    color="#e8f1ff"
                    text-color="#2863af"
                    small
                    :close="podeRemoverChip(chip)"
                    v-on="on"
                    @click:close="removeFilter(chip.key)"
                  >
                    {{ chip.label }}
                  </v-chip>
                </template>
                <span>{{ getTooltipValue(chip) }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          lg="2"
          class="d-flex justify-end"
        >
          <v-btn
            v-if="exibirChips"
            text
            :color="corPrimaria"
            @click="updateDate()"
          >
            <v-icon>
              mdi-reload-alert
            </v-icon>
            Consultar
          </v-btn>
          <v-btn
            text
            style="color: #2863af;"
            @click="toggleDrawer"
          >
            <v-icon>{{ drawer ? 'mdi-filter-minus' : 'mdi-filter-plus' }}</v-icon>
            {{ drawer ? 'Fechar filtros' : 'Filtros' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-navigation-drawer
      v-model="drawer"
      right
      temporary
      width="600"
      fixed
      attach="body"
      class="pa-4 elevation-10 drawerFiltros"
      style="z-index: 3000;"
    >
      <v-container>
        <v-row>
          <v-row>
            <v-col class="d-flex justify-end">
              <v-btn
                text
                style="color: #2863af;"
                @click="toggleDrawer"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-col cols="12">
            <transition name="filters">
              <v-row>
                <v-col
                  v-if="primeiro"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedPrimeiroDia"
                        :label="textoDataInicial"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        readonly
                        :clearable="!dataInicialPreenchida"
                        v-on="on"
                        @click:clear="limparData('dataInicio')"
                      />
                    </template>
                    <v-date-picker
                      v-model="primeiroDia"
                      no-title
                      @input="menu3 = false"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="definirHoje('primeiroDia')"
                      >
                        Hoje
                      </v-btn>
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="menu3 = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="ultimo"
                  id="menu2"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-menu
                    v-model="menu4"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        :label="textoDataFinal"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        :clearable="!dataFinalPreenchida"
                        v-on="on"
                        @click:clear="limparData('dataFim')"
                      />
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="menu4 = false"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="definirHoje('dataFim')"
                      >
                        Hoje
                      </v-btn>
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="menu4 = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="statusPrimeiro"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-menu
                    ref="menu5"
                    v-model="menu5"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedPrimeiroDiaStatus"
                        label="Data Status Inicial"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        readonly
                        :clearable="!dataStatusPreenchida"
                        v-on="on"
                        @click:clear="limparData('dataInicioStatus')"
                      />
                    </template>
                    <v-date-picker
                      v-model="primeiroDiaStatus"
                      no-title
                      @input="menu5 = false"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="definirHoje('dataInicioStatus')"
                      >
                        Hoje
                      </v-btn>
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="menu5 = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="statusUltimo"
                  id="menu6"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-menu
                    v-model="menu6"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormattedStaus"
                        label="Data Status Final"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        :clearable="!dataStatusFinalPreenchida"
                        v-on="on"
                        @click:clear="limparData('dataFimStatus')"
                      />
                    </template>
                    <v-date-picker
                      v-model="dateStatus"
                      no-title
                      @input="menu6 = false"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="definirHoje('dataFimStatus')"
                      >
                        Hoje
                      </v-btn>
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="menu6 = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="empresas"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="select"
                    :items="empresa"
                    item-value="id"
                    item-text="nomeExibicao"
                    label="Empresas"
                    multiple
                    return-object
                    @change="filtrarEmpresa()"
                  />
                </v-col>
                <v-col
                  v-if="vendedores && filtros.vendedor.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectVendedores"
                    :items="vendedorFilter.length > 0 ? vendedorFilter : (filterVendedores.length > 0 ? filterVendedores : vendedor)"
                    item-value="idExibicao"
                    :item-text="formatVendedor"
                    label="Vendedores"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.vendedor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.vendedor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectVendedores.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione um vendedor
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroVendedores"
                            v-model="filtroVendedores"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Vendedores"
                            @change="filterVendedoresToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleVendedores"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectVendedores.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconVendedores }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="areas && filtros.area.length"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectArea"
                    :items="areaFilter.length > 0 ? areaFilter : (filterArea.length > 0 ? filterArea : area)"
                    item-value="idExibicao"
                    :item-text="formatArea"
                    label="Área Comercial"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.area }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.area }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectArea.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      selecione uma área
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroAreas"
                            v-model="filtroAreas"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Redes"
                            @change="filterAreasToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleAreas"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectArea.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconAreas }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todas
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="redes && filtros.rede.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectRede"
                    :items="redeFilter.length > 0 ? redeFilter : (filterRede.length > 0 ? filterRede : rede)"
                    item-value="idExibicao"
                    :item-text="formatRede"
                    label="Rede"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.rede }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.rede }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectRede.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      selecione uma rede
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroRedes"
                            v-model="filtroRedes"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Redes"
                            @change="filterRedesToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleRedes"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectRede.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconRedes }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="supervisores && supervisor.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectSupervisor"
                    :items="supervisorFilter.length > 0 ? supervisorFilter : (filterSupervisor.length > 0 ? filterSupervisor : supervisor)"
                    item-value="idExibicao"
                    :item-text="formatSupervisor"
                    label="Supervisor"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.supervisor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.supervisor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectSupervisor.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione um supervisor
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroSupervisor"
                            v-model="filtroSupervisor"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Supervisor(es)"
                            @change="filterSupervisorToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleSupervisor"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectSupervisor.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconSupervisor }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="receitas && filtros.receita.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectReceita"
                    :items="filterReceita.length > 0 ? filterReceita : receita"
                    item-value="idExibicao"
                    :item-text="formatReceita"
                    label="Grupo Receita"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.nome }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.nome }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectReceita.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="segmentos && filtros.segmento.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectSegmento"
                    :items="filterSegmento.length > 0 ? filterSegmento : segmento"
                    item-value="idExibicao"
                    :item-text="formatSegmento"
                    label="Segmento Cliente"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.segmento }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.segmento }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectSegmento.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="produtos && filtros.produto.length > 0"
                  id="selectProduto"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectProduto"
                    :items="produtoFilter.length > 0 ? produtoFilter : (filterProduto.length > 0 ? filterProduto : produto)"
                    item-value="idExibicao"
                    :item-text="formatProduto"
                    label="Produto"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.produto }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.produto }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectProduto.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione um produto
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroProduto"
                            v-model="filtroProduto"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Produto(s)"
                            @change="filterProdutoToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleProduto"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectProduto.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconProduto }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="linhaProducao && filtros.linhasProducao.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectLinhasProducao"
                    :items="linhasProducaoFilter.length > 0 ? linhasProducaoFilter : (filterLinhasProducao.length > 0 ? filterLinhasProducao : linhasProducao)"
                    item-value="idExibicao"
                    :item-text="formatLinhasProducao"
                    label="Linhas Produção"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.linhaProducao }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.linhaProducao }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectPromotor.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      selecione uma linha produção
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroLinhaProducao"
                            v-model="filtroLinhasProducao"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Linhas Produção"
                            @change="filterLinhasProducaoToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleLinhasProducao"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectLinhasProducao.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconLinhasProducao }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="classificacoes && filtros.classificacao.length > 0"
                  id="selectClassificacao"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectClassificacao"
                    :items="classificacaoFilter.length > 0 ? classificacaoFilter : (filterClassificacao.length > 0 ? filterClassificacao : classificacao)"
                    item-value="idExibicao"
                    :item-text="formatClassificacao"
                    label="Classificação"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.classificacaoExibicao }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.classificacaoExibicao }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectClassificacao.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione uma classificação
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroClassificacao"
                            v-model="filtroClassificacao"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Classificação(ões)"
                            @change="filterClassificacaoToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleClassificacao"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectClassificacao.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconClassificacao }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="cidades && filtros.cidade.length > 0"
                  id="selectCidades"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectCidade"
                    :items="filterCidade.length > 0 ? filterCidade : cidade"
                    item-value="id"
                    item-text="cidade"
                    label="Cidades"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.cidade }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.cidade }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectCidade.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione uma cidade
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroCidades"
                            v-model="filtroCidade"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Cidades"
                            @change="filterCidadesToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleCidades"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectCidade.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconCidades }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="categorias && filtros.categoria.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectCategoria"
                    :items="categoriaFilter.length > 0 ? categoriaFilter : (filterCategoria.length > 0 ? filterCategoria : categoria)"
                    item-value="idExibicao"
                    :item-text="formatCategoria"
                    label="Categorias"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.categoria }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.categoria }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectCategoria.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      selecione uma categoria
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroCategoria"
                            v-model="filtroCategoria"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Categoria"
                            @change="filterCategoriaToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleCategoria"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectCategoria.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconCategoria }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="promotores && filtros.promotor.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectPromotor"
                    :items="promotorFilter.length > 0 ? promotorFilter : (filterPromotor.length > 0 ? filterPromotor : promotor)"
                    item-value="idExibicao"
                    :item-text="formatPromotor"
                    label="Promotores"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.promotor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.promotor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectPromotor.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      selecione um promotor
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroPromotor"
                            v-model="filtroPromotor"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Promotor"
                            @change="filterPromotorToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="togglePromotor"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectPromotor.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconPromotor }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="motoristas && filtros.motorista.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectMotorista"
                    :items="motoristaFilter.length > 0 ? motoristaFilter : (filterMotorista.length > 0 ? filterMotorista : motorista)"
                    item-value="idExibicao"
                    :item-text="formatMotorista"
                    label="Motorista(s)"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.motorista }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.motorista }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectMotorista.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      selecione um motorista
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroPromotor"
                            v-model="filtroMotorista"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Motorista"
                            @change="filterMotoristaToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleMotorista"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectMotorista.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconMotorista }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="statusEntregas && filtros.statusEntrega.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectStatusEntrega"
                    :items="statusEntregaFilter.length > 0 ? statusEntregaFilter : (filterStatusEntrega.length > 0 ? filterStatusEntrega : status)"
                    item-value="idExibicao"
                    :item-text="formatStatusEntrega"
                    label="Status Entrega(s)"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.status }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.status }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectStatusEntrega.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      selecione um status
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroStatusEntrega"
                            v-model="filtroStatusEntrega"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Status Entrega"
                            @change="filterStatusEntregaToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleStatusEntrega"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectStatusEntrega.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconStatusEnterga }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="ordemEntregaExibicao"
                  id="selectEmpresa"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <v-select
                    v-model="selectOrdem"
                    :items="ordemEntrega"
                    item-value="id"
                    item-text="nomeExibicao"
                    label="Ordem de Entrega"
                    return-object
                    @change="filtrarOrdemEntrega()"
                  />
                </v-col>
                <v-col
                  v-if="camposOrdenacao"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectOpcaoOrdenacao"
                    :items="opcaoOrdenacao"
                    item-value="id"
                    item-text="nomeExibicao"
                    label="Campos Ordenação"
                    multiple
                    return-object
                  />
                </v-col>
                <v-col
                  v-if="ordemOrdenacao"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectOrientacaoOrdem"
                    :items="orientacaoOrdem"
                    item-value="id"
                    item-text="nomeExibicao"
                    label="Ordem"
                    return-object
                  />
                  <!-- @change="modificarOrdem()" -->
                </v-col>

                <v-col
                  v-if="cliente && filtros.clientes.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectClientes"
                    :items="clientesFilter.length > 0 ? clientesFilter : (filterClientes.length > 0 ? filterClientes : clientes)"
                    item-value="idExibicao"
                    :item-text="formatClientes"
                    label="Clientes"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.cliente }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.cliente }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectClientes.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione um cliente
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroClientes"
                            v-model="filtroClientes"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Clientes"
                            @change="filterClientesToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleClientes"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectClientes.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconClientes }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-btn
                    id="btnRefazer"
                    class="col-12 lg-12 text-h4"
                    small
                    :color="corPrimaria"
                    dark
                    @click="updateDate()"
                  >
                    <v-icon>
                      mdi-reload-alert
                    </v-icon>
                    Consultar
                  </v-btn>
                </v-col>
              </v-row>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>
<script>
  import eventoEmit from './EventoEmit'

  export default {
    name: 'DashboardCoreFiltroDatas',
    emits: ['updateDados', 'ordenarDadosEntrega', 'ordenarDados'],
    components: {
      DashboardCoreSnackbar: () => import('./Snackbar'),
    },
    props: {
      primeiro: {
        type: Boolean,
        default: false,
      },
      dataInicialPreenchida: {
        type: Boolean,
        default: true,
      },
      textoDataInicial: {
        type: String,
        default: 'Data Inicial',
      },
      ultimo: {
        type: Boolean,
        default: false,
      },
      dataFinalPreenchida: {
        type: Boolean,
        default: true,
      },
      textoDataFinal: {
        type: String,
        default: 'Data Final',
      },
      statusPrimeiro: {
        type: Boolean,
        default: false,
      },
      dataStatusPreenchida: {
        type: Boolean,
        default: false,
      },
      statusUltimo: {
        type: Boolean,
        default: false,
      },
      dataStatusFinalPreenchida: {
        type: Boolean,
        default: false,
      },
      empresas: {
        type: Boolean,
        default: false,
      },
      url: {
        type: String,
        default: '',
      },
      vendedores: {
        type: Boolean,
        default: false,
      },
      areas: {
        type: Boolean,
        default: false,
      },
      redes: {
        type: Boolean,
        default: false,
      },
      supervisores: {
        type: Boolean,
        default: false,
      },
      receitas: {
        type: Boolean,
        default: false,
      },
      segmentos: {
        type: Boolean,
        default: false,
      },
      empresavisible: {
        type: Boolean,
        default: false,
      },
      classificacoes: {
        type: Boolean,
        default: false,
      },
      produtos: {
        type: Boolean,
        default: false,
      },
      cidades: {
        type: Boolean,
        default: false,
      },
      categorias: {
        type: Boolean,
        default: false,
      },
      promotores: {
        type: Boolean,
        default: false,
      },
      linhaProducao: {
        type: Boolean,
        default: false,
      },
      habilitarFiltrosData: {
        type: Boolean,
        default: true,
      },
      motoristas: {
        type: Boolean,
        default: false,
      },
      statusEntregas: {
        type: Boolean,
        default: false,
      },
      ordemEntregaExibicao: {
        type: Boolean,
        default: false,
      },
      camposOrdenacao: {
        type: Boolean,
        default: false,
      },
      ordemOrdenacao: {
        type: Boolean,
        default: false,
      },
      cliente: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      primeiroDia: '',
      date: '',
      primeiroDiaStatus: (new Date()).toISOString().substr(0, 10),
      dateStatus: (new Date()).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      select: [],
      esconder: false,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
      permissaoGestaoComercial: '',
      empresa: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      selectVendedores: [],
      vendedor: [],
      vendedorRelacao: [],
      filterVendedores: [],
      area: [],
      selectArea: [],
      filterArea: [],
      rede: [],
      selectRede: [],
      filterRede: [],
      supervisor: [],
      selectSupervisor: [],
      filterSupervisor: [],
      receita: [],
      selectReceita: [],
      filterReceita: [],
      segmento: [],
      selectSegmento: [],
      filterSegmento: [],
      vendedorFilter: [],
      areaFilter: [],
      redeFilter: [],
      supervisorFilter: [],
      filtroVendedores: '',
      filtroAreas: '',
      filtroRedes: '',
      filtroSupervisor: '',
      selectClassificacao: [],
      classificacao: [],
      filterClassificacao: [],
      classificacaoFilter: [],
      filtroClassificacao: '',
      selectProduto: [],
      produto: [],
      filterProduto: [],
      produtoFilter: [],
      filtroProduto: '',
      selectCidade: [],
      cidade: [],
      filterCidade: [],
      cidadeFilter: [],
      filtroCidade: '',
      selectCategoria: [],
      categoria: [],
      filterCategoria: [],
      categoriaFilter: [],
      filtroCategoria: '',
      selectPromotor: [],
      promotor: [],
      filterPromotor: [],
      promotorFilter: [],
      filtroPromotor: '',
      selectLinhasProducao: [],
      linhasProducao: [],
      filterLinhasProducao: [],
      linhasProducaoFilter: [],
      filtroLinhasProducao: '',
      selectMotorista: [],
      motorsita: [],
      filterMotorista: [],
      motoristaFilter: [],
      filtroMotorista: '',
      selectStatusEntrega: [],
      status: [],
      filterStatusEntrega: [],
      statusEntregaFilter: [],
      filtroStatusEntrega: '',
      selectClientes: [],
      clientes: [],
      filterClientes: [],
      clientesFilter: [],
      filtroClientes: '',
      expandFiltro: false,
      icone: 'mdi-chevron-down',
      textFiltro: 'Exibir Filtro',
      enableFiltros: false,
      drawer: false,
      exibirChips: false,
      filtrosCarregados: localStorage.filtrosCarregados !== 'false',
      ordemEntrega: [
        { id: 1, nomeExibicao: 'Ordem Magis Ti' },
        { id: 2, nomeExibicao: 'Ordem Entregue pelo motorista' },
      ],
      selectOrdem: null,
      opcaoOrdenacao: [
        { id: 1, nomeExibicao: 'Entrega', campoOrdenacao: 'id_romaneio', campoOrdenacaoVue: 'romaneioId' },
        { id: 2, nomeExibicao: 'Status', campoOrdenacao: 'status_romaneio', campoOrdenacaoVue: 'status' },
        { id: 3, nomeExibicao: 'Data Status', campoOrdenacao: 'data_status_romaneio', campoOrdenacaoVue: 'dataStatus' },
      ],
      selectOpcaoOrdenacao: [],
      orientacaoOrdem: [
        { id: 1, nomeExibicao: 'Crescente', ordemOrdenacao: 'ASC' },
        { id: 2, nomeExibicao: 'Decrescente', ordemOrdenacao: 'DESC' },
      ],
      selectOrientacaoOrdem: null,
    }),

    computed: {
      filtros () {
        this.montarDadosFiltros(this.$store.state.filtros)

        return this.$store.state.filtros
      },

      appliedFilters () {
        const chips = []
        var i = 0

        // Datas
        if (this.primeiro && this.primeiroDia) {
          chips.push({
            key: 'dataInicio',
            label: this.textoDataInicial + ': ' + this.formatDatePrimeiroDia(this.primeiroDia),
          })
        }

        if (this.ultimo && this.date) {
          chips.push({
            key: 'dataFim',
            label: this.textoDataFinal + ': ' + this.formatDatePrimeiroDia(this.date),
          })
        }

        if (this.statusPrimeiro && this.primeiroDiaStatus) {
          chips.push({
            key: 'dataInicioStatus',
            label: `Data Status Início: ${this.formatDatePrimeiroDiaStatus(this.primeiroDiaStatus)}`,
          })
        }

        if (this.statusUltimo && this.dateStatus) {
          chips.push({
            key: 'dataFimStatus',
            label: `Data Status Fim: ${this.formatDatePrimeiroDiaStatus(this.dateStatus)}`,
          })
        }

        if (this.empresas && this.select?.length) {
          const empresaAux = []

          for (i in this.select) {
            empresaAux.push(this.select[i].nomeExibicao)
          }

          chips.push({
            key: 'empresas',
            label: `Empresa(s) (${this.select.length})`,
            value: empresaAux,
          })
        }

        if (this.selectVendedores?.length) {
          const vendedorAux = []

          for (i in this.selectVendedores) {
            vendedorAux.push(this.selectVendedores[i].vendedor + ' - ' + this.selectVendedores[i].nomeBd)
          }

          chips.push({
            key: 'vendedores',
            label: `Vendedor(es) (${this.selectVendedores.length})`,
            value: vendedorAux,
          })
        }

        if (this.selectArea?.length) {
          const areaAux = []

          for (i in this.selectArea) {
            areaAux.push(this.selectArea[i].area + ' - ' + this.selectArea[i].nomeBd)
          }

          chips.push({
            key: 'areas',
            label: `Área(s) (${this.selectArea.length})`,
            value: areaAux,
          })
        }

        if (this.selectRede?.length) {
          const redeAux = []

          for (i in this.selectRede) {
            redeAux.push(this.selectRede[i].rede + ' - ' + this.selectRede[i].nomeBd)
          }

          chips.push({
            key: 'redes',
            label: `Rede(s) (${this.selectRede.length})`,
            value: redeAux,
          })
        }

        if (this.selectSupervisor?.length) {
          const supervisorAux = []

          for (i in this.selectSupervisor) {
            supervisorAux.push(this.selectSupervisor[i].supervisor + ' - ' + this.selectSupervisor[i].nomeBd)
          }

          chips.push({
            key: 'supervisores',
            label: `Supervisor(es) (${this.selectSupervisor.length})`,
            value: supervisorAux,
          })
        }

        if (this.selectReceita?.length) {
          const receitaAux = []

          for (i in this.selectReceita) {
            receitaAux.push(this.selectReceita[i].nome + ' - ' + this.selectReceita[i].nomeBd)
          }

          chips.push({
            key: 'receita',
            label: `Receita(s) (${this.selectReceita.length})`,
            value: receitaAux,
          })
        }

        if (this.selectSegmento?.length) {
          const segmentoAux = []

          for (i in this.selectSegmento) {
            segmentoAux.push(this.selectSegmento[i].segmento + ' - ' + this.selectSegmento[i].nomeBd)
          }

          chips.push({
            key: 'segmento',
            label: `Segmento(s) (${this.selectSegmento.length})`,
            value: segmentoAux,
          })
        }

        if (this.selectProduto?.length) {
          const produtoAux = []

          for (i in this.selectProduto) {
            produtoAux.push(this.selectProduto[i].produto + ' - ' + this.selectProduto[i].nomeBd)
          }

          chips.push({
            key: 'produtos',
            label: `Produto(s) (${this.selectProduto.length})`,
            value: produtoAux,
          })
        }

        if (this.selectLinhasProducao?.length) {
          const linhaAux = []

          for (i in this.selectLinhasProducao) {
            linhaAux.push(this.selectLinhasProducao[i].linhaProducao + ' - ' + this.selectLinhasProducao[i].nomeBd)
          }

          chips.push({
            key: 'linhaProducao',
            label: `Linha(s) Produção(ões) (${this.selectLinhasProducao.length})`,
            value: linhaAux,
          })
        }

        if (this.selectClassificacao?.length) {
          const classificacaoAux = []

          for (i in this.selectClassificacao) {
            classificacaoAux.push(this.selectClassificacao[i].classificacao + ' - ' + this.selectClassificacao[i].nomeBd)
          }

          chips.push({
            key: 'classificacao',
            label: `Classificação(ões) (${this.selectClassificacao.length})`,
            value: classificacaoAux,
          })
        }

        if (this.selectCidade?.length) {
          const cidadeAux = []

          for (i in this.selectCidade) {
            cidadeAux.push(this.selectCidade[i].cidade)
          }

          chips.push({
            key: 'cidade',
            label: `Cidade(s) (${this.selectCidade.length})`,
            value: cidadeAux,
          })
        }

        if (this.selectCategoria?.length) {
          const categoriaAux = []

          for (i in this.selectCategoria) {
            categoriaAux.push(this.selectCategoria[i].categoria + ' - ' + this.selectCategoria[i].nomeBd)
          }

          chips.push({
            key: 'categorias',
            label: `Categoria(s) (${this.selectCategoria.length})`,
            value: categoriaAux,
          })
        }

        if (this.selectPromotor?.length) {
          const promotorAux = []

          for (i in this.selectPromotor) {
            promotorAux.push(this.selectPromotor[i].promotor + ' - ' + this.selectPromotor[i].nomeBd)
          }

          chips.push({
            key: 'promoteres',
            label: `Promotor(es) (${this.selectPromotor.length})`,
            value: promotorAux,
          })
        }

        if (this.selectMotorista?.length) {
          const motoristaAux = []

          for (i in this.selectMotorista) {
            motoristaAux.push(this.selectMotorista[i].motorista + ' - ' + this.selectMotorista[i].nomeBd)
          }

          chips.push({
            key: 'motoristas',
            label: `Motorista(s) (${this.selectMotorista.length})`,
            value: motoristaAux,
          })
        }

        if (this.selectStatusEntrega?.length) {
          const statusEntregaAux = []

          for (i in this.selectStatusEntrega) {
            statusEntregaAux.push(this.selectStatusEntrega[i].status + ' - ' + this.selectStatusEntrega[i].nomeBd)
          }

          chips.push({
            key: 'statusEntrega',
            label: `Status Entrega(s) (${this.selectStatusEntrega.length})`,
            value: statusEntregaAux,
          })
        }

        if (this.selectOrdem) {
          chips.push({
            key: 'ordemExibicao',
            label: `${this.selectOrdem.nomeExibicao}`,
            value: [this.selectOrdem.nomeExibicao],
          })
        }

        if (this.selectOpcaoOrdenacao?.length) {
          const selectOpcaoOrdenacaoAux = []

          for (i in this.selectOpcaoOrdenacao) {
            selectOpcaoOrdenacaoAux.push(this.selectOpcaoOrdenacao[i].nomeExibicao)
          }

          chips.push({
            key: 'camposOrdenacao',
            label: `Tipo(s) ordenação(ões) (${this.selectOpcaoOrdenacao.length})`,
            value: selectOpcaoOrdenacaoAux,
          })
        }

        if (this.selectOrientacaoOrdem) {
          chips.push({
            key: 'ordemDados',
            label: `Ordem exibição: ${this.selectOrientacaoOrdem.nomeExibicao}`,
            value: [this.selectOrientacaoOrdem.nomeExibicao],
          })
        }

        if (this.selectClientes?.length) {
          const clientesAux = []

          for (i in this.selectClientes) {
            clientesAux.push(this.selectClientes[i].cliente + ' - ' + this.selectClientes[i].nomeBd)
          }

          chips.push({
            key: 'clientes',
            label: `Cliente(s) (${this.selectClientes.length})`,
            value: clientesAux,
          })
        }

        return chips
      },

      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },

      computedDateFormattedStaus () {
        return this.formatDateStatus(this.dateStatus)
      },

      computedPrimeiroDiaStatus () {
        return this.formatDatePrimeiroDiaStatus(this.primeiroDiaStatus)
      },

      likesAllVendedores () {
        const baseVendedores =
          this.vendedorFilter.length > 0
            ? this.vendedorFilter
            : this.filterVendedores.length > 0
              ? this.filterVendedores
              : this.vendedor

        return this.selectVendedores.length === baseVendedores.length
      },

      likesSomeVendedores () {
        return this.selectVendedores.length > 0 && !this.likesAllVendedores
      },

      iconVendedores () {
        if (this.likesAllVendedores) return 'mdi-close-box'
        if (this.likesSomeVendedores) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllAreas () {
        const baseAreas =
          this.areaFilter.length > 0
            ? this.areaFilter
            : this.filterArea.length > 0
              ? this.filterArea
              : this.area

        return this.selectArea.length === baseAreas.length
      },

      likesSomeAreas () {
        return this.selectArea.length > 0 && !this.likesAllAreas
      },

      iconAreas () {
        if (this.likesAllAreas) return 'mdi-close-box'
        if (this.likesSomeAreas) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllRedes () {
        const baseRedes =
          this.redeFilter.length > 0
            ? this.redeFilter
            : this.filterRede.length > 0
              ? this.filterRede
              : this.rede

        return this.selectRede.length === baseRedes.length
      },

      likesSomeRedes () {
        return this.selectRede.length > 0 && !this.likesAllRedes
      },

      iconRedes () {
        if (this.likesAllRedes) return 'mdi-close-box'
        if (this.likesSomeRedes) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllSupervisores () {
        const baseSupervisor =
          this.supervisorFilter.length > 0
            ? this.supervisorFilter
            : this.filterSupervisor.length > 0
              ? this.filterSupervisor
              : this.supervisor

        return this.selectSupervisor.length === baseSupervisor.length
      },

      likesSomeSupervisores () {
        return this.selectSupervisor.length > 0 && !this.likesAllSupervisores
      },

      iconSupervisor () {
        if (this.likesAllSupervisores) return 'mdi-close-box'
        if (this.likesSomeSupervisores) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllClassificacao () {
        const baseClassificacao =
          this.classificacaoFilter.length > 0
            ? this.classificacaoFilter
            : this.filterClassificacao.length > 0
              ? this.filterClassificacao
              : this.classificacao

        return this.selectClassificacao.length === baseClassificacao.length
      },

      likesSomeClassificacao () {
        return this.selectClassificacao.length > 0 && !this.likesAllClassificacao
      },

      iconClassificacao () {
        if (this.likesAllClassificacao) return 'mdi-close-box'
        if (this.likesSomeClassificacao) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllProduto () {
        const baseProduto =
          this.produtoFilter.length > 0
            ? this.produtoFilter
            : this.filterProduto.length > 0
              ? this.filterProduto
              : this.produto

        return this.selectProduto.length === baseProduto.length
      },

      likesSomeProduto () {
        return this.selectProduto.length > 0 && !this.likesAllProduto
      },

      iconProduto () {
        if (this.likesAllProduto) return 'mdi-close-box'
        if (this.likesSomeProduto) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllCidades () {
        const baseCidade =
          this.filterCidade.length > 0
            ? this.filterCidade
            : this.cidade

        return this.selectCidade.length === baseCidade.length
      },

      likesSomeCidade () {
        return this.selectCidade.length > 0 && !this.likesAllCidades
      },

      iconCidades () {
        if (this.likesAllCidades) return 'mdi-close-box'
        if (this.likesSomeCidade) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllCategoria () {
        const baseCategoria =
          this.categoriaFilter.length > 0
            ? this.categoriaFilter
            : this.filterCategoria.length > 0
              ? this.filterCategoria
              : this.categoria

        return this.selectCategoria.length === baseCategoria.length
      },

      likesSomeCategoria () {
        return this.selectCategoria.length > 0 && !this.likesAllCategoria
      },

      iconCategoria () {
        if (this.likesAllCategoria) return 'mdi-close-box'
        if (this.likesSomeCategoria) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllPromotor () {
        const basePromotor =
          this.promotorFilter.length > 0
            ? this.promotorFilter
            : this.filterPromotor.length > 0
              ? this.filterPromotor
              : this.promotor

        return this.selectPromotor.length === basePromotor.length
      },

      likesSomePromotor () {
        return this.selectPromotor.length > 0 && !this.likesAllPromotor
      },

      iconPromotor () {
        if (this.likesAllPromotor) return 'mdi-close-box'
        if (this.likesSomePromotor) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllLinhasProducao () {
        const baseLinhasProducao =
          this.linhasProducaoFilter.length > 0
            ? this.linhasProducaoFilter
            : this.filterLinhasProducao.length > 0
              ? this.filterLinhasProducao
              : this.linhasProducao

        return this.selectLinhasProducao.length === baseLinhasProducao.length
      },

      likesSomeLinhasProducao () {
        return this.selectLinhasProducao.length > 0 && !this.likesAllLinhasProducao
      },

      iconLinhasProducao () {
        if (this.likesAllLinhasProducao) return 'mdi-close-box'
        if (this.likesSomeLinhasProducao) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllMotorista () {
        const baseMotorista =
          this.motoristaFilter.length > 0
            ? this.motoristaFilter
            : this.filterMotorista.length > 0
              ? this.filterMotorista
              : this.motorista

        return this.selectMotorista.length === baseMotorista.length
      },

      likesSomeMotorista () {
        return this.selectMotorista.length > 0 && !this.likesAllMotorista
      },

      iconMotorista () {
        if (this.likesAllMotorista) return 'mdi-close-box'
        if (this.likesSomeMotorista) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllStatusEntrega () {
        const baseStatusEntrega =
          this.statusEntregaFilter.length > 0
            ? this.statusEntregaFilter
            : this.filterStatusEntrega.length > 0
              ? this.filterStatusEntrega
              : this.status

        return this.selectStatusEntrega.length === baseStatusEntrega.length
      },

      likesSomeStatusEntrega () {
        return this.selectStatusEntrega.length > 0 && !this.likesAllStatusEntrega
      },

      iconStatusEnterga () {
        if (this.likesAllStatusEntrega) return 'mdi-close-box'
        if (this.likesSomeStatusEntrega) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllClientes () {
        const baseClientes =
          this.clientesFilter.length > 0
            ? this.clientesFilter
            : this.filterClientes.length > 0
              ? this.filterClientes
              : this.clientes

        return this.selectClientes.length === baseClientes.length
      },

      likesSomeClientes () {
        return this.selectClientes.length > 0 && !this.likesAllClientes
      },

      iconClientes () {
        if (this.likesAllClientes) return 'mdi-close-box'
        if (this.likesSomeClientes) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },
    },

    watch: {
      'filtros.empresas': {
        immediate: true,
        handler (empresa) {
          if (empresa && empresa.length === 1) {
            this.select = [...empresa]
          }
        },
      },

      date (val) {
        // this.date = this.formatDate(this.date)
        this.dateFormatted = this.formatDate(this.date)
      },

      primeiro: function (val) {
        this.primeiro = val
      },

      dataInicialPreenchida: function (val) {
        this.dataInicialPreenchida = val
      },

      textoDataInicial: function (val) {
        this.textoDataInicial = val
      },

      ultimo: function (val) {
        this.ultimo = val
      },

      dataFinalPreenchida: function (val) {
        this.dataFinalPreenchida = val
      },

      textoDataFinal: function (val) {
        this.textoDataFinal = val
      },

      statusPrimeiro: function (val) {
        this.statusPrimeiro = val
      },

      dataStatusPreenchida: function (val) {
        this.dataStatusPreenchida = val
      },

      statusUltimo: function (val) {
        this.statusUltimo = val
      },

      dataStatusFinalPreenchida: function (val) {
        this.dataStatusFinalPreenchida = val
      },

      empresas: function (val) {
        this.empresas = val
      },

      url: function (val) {
        this.url = val
      },

      vendedores: function (val) {
        this.vendedores = val
      },

      areas: function (val) {
        this.areas = val
      },

      redes: function (val) {
        this.redes = val
      },

      supervisores: function (val) {
        this.supervisores = val
      },

      receitas: function (val) {
        this.receitas = val
      },

      segmentos: function (val) {
        this.segmentos = val
      },

      empresavisible: function (val) {
        this.empresavisible = val
      },

      produtos: function (val) {
        this.produtos = val
      },

      cidades: function (val) {
        this.cidades = val
      },

      categorias: function (val) {
        this.categorias = val
      },

      promotores: function (val) {
        this.promotores = val
      },

      motoristas: function (val) {
        this.motoristas = val
      },

      statusEntregas: function (val) {
        this.statusEntregas = val
      },

      ordemEntregaExibicao: function (val) {
        this.ordemEntregaExibicao = val
      },

      camposOrdenacao: function (val) {
        this.camposOrdenacao = val
      },

      ordemOrdenacao: function (val) {
        this.ordemOrdenacao = val
      },

      linhaProducao: function (val) {
        this.linhaProducao = val
      },

      habilitarFiltrosData: function (val) {
        this.habilitarFiltrosData = val
      },

      cliente: function (val) {
        this.cliente = val
      },
    },

    mounted () {
      this.$store.dispatch('carregarFiltros')

      this.exibirChips = true

      if (this.dataInicialPreenchida) {
        this.primeiroDia = this.primeiroDiaMesAtual()
      }

      if (this.dataFinalPreenchida) {
        this.date = this.ultimoDiaMesAtual()
      }

      if (this.dataStatusPreenchida) {
        this.primeiroDiaStatus = this.primeiroDiaMesAtual()
      }

      if (this.dataStatusFinalPreenchida) {
        this.dateStatus = this.ultimoDiaMesAtual()
      }
    },

    methods: {
      primeiroDiaMesAtual () {
        const dataSalva = localStorage.getItem('dataInicial')

        if (dataSalva) {
          return dataSalva
        }

        const hoje = new Date()

        return new Date(hoje.getFullYear(), hoje.getMonth(), 1).toISOString().substr(0, 10)
      },

      ultimoDiaMesAtual () {
        const dataSalva = localStorage.getItem('dataFinal')

        if (dataSalva) {
          return dataSalva
        }

        const hoje = new Date()

        return new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).toISOString().substr(0, 10)
      },

      definirHoje (item) {
        const hoje = new Date()

        if (item === 'primeiroDia') {
          this.primeiroDia = hoje.toISOString().substr(0, 10)
        } else if (item === 'dataFim') {
          this.date = hoje.toISOString().substr(0, 10)
        } else if (item === 'dataInicioStatus') {
          this.primeiroDiaStatus = hoje.toISOString().substr(0, 10)
        } else if (item === 'dataFimStatus') {
          this.dateStatus = hoje.toISOString().substr(0, 10)
        }
      },

      montarDadosFiltros (dados) {
        this.supervisor = dados.supervisor
        this.empresa = dados.empresa

        if (this.empresa.length === 1) {
          this.select = this.empresa
        }

        this.vendedor = dados.vendedor
        this.vendedorRelacao = dados.vendedorRelacao
        this.area = dados.area
        this.rede = dados.rede
        this.receita = dados.receita
        this.segmento = dados.segmento
        this.classificacao = dados.classificacao
        this.produto = dados.produto
        this.cidade = dados.cidade
        this.categoria = dados.categoria
        this.promotor = dados.promotor
        this.linhasProducao = dados.linhasProducao
        this.motorista = dados.motorista
        this.status = dados.statusEntrega
        this.clientes = dados.clientes
      },

      toggleDrawer () {
        this.drawer = !this.drawer
      },

      limparData (tipo) {
        switch (tipo) {
          case 'dataInicio':
            if (!this.dataInicialPreenchida) {
              this.primeiroDia = ''
            }

            break
          case 'dataFim':
            if (!this.dataFinalPreenchida) {
              this.date = ''
            }

            break
          case 'dataInicioStatus':
            if (!this.dataStatusPreenchida) {
              this.primeiroDiaStatus = ''
            }

            break
          case 'dataFimStatus':
            if (!this.dataStatusFinalPreenchida) {
              this.dateStatus = ''
            }

            break
        }
      },

      podeRemoverChip (chip) {
        const bloqueados = {
          dataInicio: this.dataInicialPreenchida,
          dataFim: this.dataFinalPreenchida,
          dataInicioStatus: this.dataStatusPreenchida,
          dataFimStatus: this.dataStatusFinalPreenchida,
        }

        // Se não for um filtro controlado, pode remover
        if (!Object.keys(bloqueados).includes(chip.key)) {
          return true
        }

        // Se for controlado:
        // só pode remover se a flag for FALSE
        return !bloqueados[chip.key]
      },

      removeFilter (key) {
        switch (key) {
          case 'empresas':
            this.select = []
            break
          case 'vendedores':
            this.selectVendedores = []
            break
          case 'areas':
            this.selectArea = []
            break
          case 'redes':
            this.selectRede = []
            break
          case 'supervisores':
            this.selectSupervisor = []
            break
          case 'receita':
            this.selectReceita = []
            break
          case 'segmento':
            this.selectSegmento = []
            break
          case 'produtos':
            this.selectProduto = []
            break
          case 'linhaProducao':
            this.selectLinhasProducao = []
            break
          case 'classificacao':
            this.selectClassificacao = []
            break
          case 'cidade':
            this.selectCidade = []
            break
          case 'categorias':
            this.selectCategoria = []
            break
          case 'promoteres':
            this.selectPromotor = []
            break
          case 'motoristas':
            this.selectMotorista = []
            break
          case 'clientes':
            this.selectClientes = []
            break
          case 'statusEntrega':
            this.selectStatusEntrega = []
            break
          case 'ordemExibicao':
            this.selectOrdem = null
            this.filtrarOrdemEntrega()
            break
          case 'camposOrdenacao':
            this.selectOpcaoOrdenacao = []
            break
          case 'ordemDados':
            this.selectOrientacaoOrdem = null
            this.modificarOrdem()
            break
          case 'dataInicioStatus':
            if (!this.dataInicialPreenchida) {
              this.primeiroDiaStatus = ''
            }

            break
          case 'dataFimStatus':
            if (!this.dataFinalPreenchida) {
              this.dateStatus = ''
            }

            break
          case 'dataInicio':
            if (!this.dataStatusPreenchida) {
              this.primeiroDia = ''
            }

            break
          case 'dataFim':
            if (!this.dataStatusFinalPreenchida) {
              this.date = ''
            }

            break
        }
      },

      getTooltipValue (chip) {
        if (Array.isArray(chip.value)) {
          return chip.value.join(', ')
        }

        return chip.label
      },

      expandirFiltro () {
        if (this.icone === 'mdi-chevron-up') {
          this.expandFiltro = false
          this.icone = 'mdi-chevron-down'
          this.textFiltro = 'Exibir Filtro'
        } else {
          this.textFiltro = 'Recolher Filtro'
          this.expandFiltro = true
          this.icone = 'mdi-chevron-up'
        }
      },

      formatVendedor (item) {
        return `${item.vendedor} - ${item.nomeBd}`
      },

      formatSupervisor (item) {
        return `${item.supervisor} - ${item.nomeBd}`
      },

      formatArea (item) {
        return `${item.area} - ${item.nomeBd}`
      },

      formatRede (item) {
        return `${item.rede} - ${item.nomeBd}`
      },

      formatReceita (item) {
        return `${item.nome} - ${item.nomeBd}`
      },

      formatSegmento (item) {
        return `${item.segmento} - ${item.nomeBd}`
      },

      formatClassificacao (item) {
        return `${item.classificacaoExibicao} - ${item.nomeBd}`
      },

      formatProduto (item) {
        return `${item.produto} - ${item.nomeBd}`
      },

      formatCategoria (item) {
        return `${item.categoria} - ${item.nomeBd}`
      },

      formatPromotor (item) {
        return `${item.promotor} - ${item.nomeBd}`
      },

      formatLinhasProducao (item) {
        return `${item.linhaProducao} - ${item.nomeBd}`
      },

      formatMotorista (item) {
        return `${item.motorista} - ${item.nomeBd}`
      },

      formatStatusEntrega (item) {
        return `${item.status} - ${item.nomeBd}`
      },

      formatClientes (item) {
        return `${item.cliente} - ${item.nomeBd}`
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateStatus (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDiaStatus (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      updateDate () {
        if (this.empresavisible && this.empresa.length > 0 && this.select.length === 0) {
          alert('Para realizar a consulta selecinar uma empresa')
        } else {
          const dadosVendedores = this.selectVendedores.length > 0 ? this.selectVendedores : (this.vendedorRelacao.length > 0 ? this.vendedorRelacao : [])

          eventoEmit.$emit('update-dados', this.primeiroDia, this.date, this.select, dadosVendedores, this.selectArea, this.selectRede, this.selectSupervisor, this.selectReceita, this.selectSegmento, this.selectClassificacao, this.selectProduto, this.selectCidade, this.selectCategoria, this.selectPromotor, this.selectLinhasProducao, this.primeiroDiaStatus, this.dateStatus, this.selectMotorista, this.selectStatusEntrega, this.selectOrdem, this.selectOpcaoOrdenacao, this.selectOrientacaoOrdem, this.selectClientes)
        }
      },

      filtrarOrdemEntrega () {
        eventoEmit.$emit('ordenar-dados-entrega', this.selectOrdem)
      },

      modificarOrdem () {
        eventoEmit.$emit('ordenar-dados', this.selectOrientacaoOrdem.ordemOrdenacao ?? 'DESC', this.selectOpcaoOrdenacao)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      toggleVendedores () {
        this.$nextTick(() => {
          if (this.likesAllVendedores) {
            this.selectVendedores = []
          } else {
            const baseVendedores =
              this.vendedorFilter.length > 0
                ? this.vendedorFilter
                : this.filterVendedores.length > 0
                  ? this.filterVendedores
                  : this.vendedor

            this.selectVendedores = [...baseVendedores]
          }
        })
      },

      filterVendedoresToggle () {
        this.vendedorFilter = []

        if (this.filtroVendedores.length > 0) {
          const baseVendedores = this.filterVendedores.length > 0 ? this.filterVendedores : this.vendedor

          this.vendedorFilter = baseVendedores.filter(vendedor => vendedor.vendedor.toLowerCase().includes(this.filtroVendedores.toLowerCase()))
        }
      },

      toggleAreas () {
        this.$nextTick(() => {
          if (this.likesAllAreas) {
            this.selectArea = []
          } else {
            const baseAreas =
              this.areaFilter.length > 0
                ? this.areaFilter
                : this.filterArea.length > 0
                  ? this.filterArea
                  : this.area

            this.selectArea = [...baseAreas]
          }
        })
      },

      filterAreasToggle () {
        this.areaFilter = []

        if (this.filtroAreas.length > 0) {
          const baseAreas = this.filterArea.length > 0 ? this.filterArea : this.area

          this.areaFilter = baseAreas.filter(area => area.area.toLowerCase().includes(this.filtroAreas.toLowerCase()))
        }
      },

      toggleRedes () {
        this.$nextTick(() => {
          if (this.likesAllRedes) {
            this.selectRede = []
          } else {
            const baseRedes =
              this.redeFilter.length > 0
                ? this.redeFilter
                : this.filterRede.length > 0
                  ? this.filterRede
                  : this.rede

            this.selectRede = [...baseRedes]
          }
        })
      },

      filterRedesToggle () {
        this.redeFilter = []

        if (this.filtroRedes.length > 0) {
          const baseRedes = this.filterRede.length > 0 ? this.filterRede : this.rede

          this.redeFilter = baseRedes.filter(rede => rede.rede.toLowerCase().includes(this.filtroRedes.toLowerCase()))
        }
      },

      toggleSupervisor () {
        this.$nextTick(() => {
          if (this.likesAllSupervisores) {
            this.selectSupervisor = []
          } else {
            const baseSupervisor =
              this.supervisorFilter.length > 0
                ? this.supervisorFilter
                : this.filterSupervisor.length > 0
                  ? this.filterSupervisor
                  : this.supervisor

            this.selectSupervisor = [...baseSupervisor]
          }
        })
      },

      filterSupervisorToggle () {
        this.supervisorFilter = []

        if (this.filtroSupervisor.length > 0) {
          const baseSupervisor = this.filterSupervisor.length > 0 ? this.filterSupervisor : this.supervisor

          this.supervisorFilter = baseSupervisor.filter(supervisor => supervisor.supervisor.toLowerCase().includes(this.filtroSupervisor.toLowerCase()))
        }
      },

      toggleClassificacao () {
        this.$nextTick(() => {
          if (this.likesAllClassificacao) {
            this.selectClassificacao = []
          } else {
            const baseClassificacao =
              this.classificacaoFilter.length > 0
                ? this.classificacaoFilter
                : this.filterClassificacao.length > 0
                  ? this.filterClassificacao
                  : this.classificacao

            this.selectClassificacao = [...baseClassificacao]
          }
        })
      },

      filterClassificacaoToggle () {
        this.classificacaoFilter = []

        if (this.filtroClassificacao.length > 0) {
          const baseClassificacao = this.filterClassificacao.length > 0 ? this.filterClassificacao : this.classificacao

          this.classificacaoFilter = baseClassificacao.filter(c => c.classificacaoExibicao.toLowerCase().includes(this.filtroClassificacao.toLowerCase()))
        }
      },

      toggleProduto () {
        this.$nextTick(() => {
          if (this.likesAllProduto) {
            this.selectProduto = []
          } else {
            const baseProduto =
              this.produtoFilter.length > 0
                ? this.produtoFilter
                : this.filterProduto.length > 0
                  ? this.filterProduto
                  : this.produto

            this.selectProduto = [...baseProduto]
          }
        })
      },

      filterProdutoToggle () {
        this.produtoFilter = []

        if (this.filtroProduto.length > 0) {
          const baseProduto = this.filterProduto.length > 0 ? this.filterProduto : this.produto

          this.produtoFilter = baseProduto.filter(p => p.produto.toLowerCase().includes(this.filtroProduto.toLowerCase()))
        }
      },

      toggleCidades () {
        this.$nextTick(() => {
          if (this.likesAllCidades) {
            this.selectCidade = []
          } else {
            const baseCidade =
              this.filterCidade.length > 0
                ? this.filterCidade
                : this.cidade

            this.selectCidade = [...baseCidade]
          }
        })
      },

      filterCidadesToggle () {
        if (this.filtroCidade.length > 0) {
          if (this.cidadeFilter.length > 0) {
            for (let i = 0; i < this.cidadeFilter.length; i++) {
              if (this.cidadeFilter[i].cidade.toLowerCase().includes(this.filtroCidade.toLowerCase())) {
                this.filterCidade.push(this.cidadeFilter[i])
              }
            }
          } else {
            for (let i = 0; i < this.cidade.length; i++) {
              if (this.cidade[i].cidade.toLowerCase().includes(this.filtroCidade.toLowerCase())) {
                this.filterCidade.push(this.cidade[i])
              }
            }
          }
        } else {
          this.filterCidade = []
        }
      },

      toggleCategoria () {
        this.$nextTick(() => {
          if (this.likesAllCategoria) {
            this.selectCategoria = []
          } else {
            const baseCategoria =
              this.categoriaFilter.length > 0
                ? this.categoriaFilter
                : this.filterCategoria.length > 0
                  ? this.filterCategoria
                  : this.categoria

            this.selectCategoria = [...baseCategoria]
          }
        })
      },

      filterCategoriaToggle () {
        this.categoriaFilter = []

        if (this.filtroCategoria.length > 0) {
          const baseCategoria = this.filterCategoria.length > 0 ? this.filterCategoria : this.categoria

          this.categoriaFilter = baseCategoria.filter(categoria => categoria.categoria.toLowerCase().includes(this.filtroCategoria.toLowerCase()))
        }
      },

      togglePromotor () {
        this.$nextTick(() => {
          if (this.likesAllPromotor) {
            this.selectPromotor = []
          } else {
            const basePromotor =
              this.promotorFilter.length > 0
                ? this.promotorFilter
                : this.filterPromotor.length > 0
                  ? this.filterPromotor
                  : this.promotor

            this.selectPromotor = [...basePromotor]
          }
        })
      },

      filterPromotorToggle () {
        this.promotorFilter = []

        if (this.filtroPromotor.length > 0) {
          const basePromotor = this.filterPromotor.length > 0 ? this.filterPromotor : this.promotor

          this.promotorFilter = basePromotor.filter(promotor => promotor.promotor.toLowerCase().includes(this.filtroPromotor.toLowerCase()))
        }
      },

      toggleLinhasProducao () {
        this.$nextTick(() => {
          if (this.likesAllLinhasProducao) {
            this.selectLinhasProducao = []
          } else {
            const baseLinhasProducao =
              this.linhasProducaoFilter.length > 0
                ? this.linhasProducaoFilter
                : this.filterLinhasProducao.length > 0
                  ? this.filterLinhasProducao
                  : this.linhasProducao

            this.selectLinhasProducao = [...baseLinhasProducao]
          }
        })
      },

      filterLinhasProducaoToggle () {
        this.linhasProducaoFilter = []

        if (this.filtroLinhasProducao.length > 0) {
          const baseLinhasProducao = this.filterLinhasProducao.length > 0 ? this.filterLinhasProducao : this.linhasProducao

          this.linhasProducaoFilter = baseLinhasProducao.filter(linhas => linhas.linhaProducao.toLowerCase().includes(this.filtroLinhasProducao.toLowerCase()))
        }
      },

      toggleMotorista () {
        this.$nextTick(() => {
          if (this.likesAllMotorista) {
            this.selectMotorista = []
          } else {
            const baseMotorista =
              this.motoristaFilter.length > 0
                ? this.motoristaFilter
                : this.filterMotorista.length > 0
                  ? this.filterMotorista
                  : this.motorista

            this.selectMotorista = [...baseMotorista]
          }
        })
      },

      filterMotoristaToggle () {
        this.motoristaFilter = []

        if (this.filtroMotorista.length > 0) {
          const baseMotorista = this.filterMotorista.length > 0 ? this.filterMotorista : this.motorista

          this.motoristaFilter = baseMotorista.filter(motorista => motorista.motorista.toLowerCase().includes(this.filtroMotorista.toLowerCase()))
        }
      },

      toggleStatusEntrega () {
        this.$nextTick(() => {
          if (this.likesAllStatusEntrega) {
            this.selectStatusEntrega = []
          } else {
            const baseStatusEntrega =
              this.statusEntregaFilter.length > 0
                ? this.statusEntregaFilter
                : this.filterStatusEntrega.length > 0
                  ? this.filterStatusEntrega
                  : this.status

            this.selectStatusEntrega = [...baseStatusEntrega]
          }
        })
      },

      filterStatusEntregaToggle () {
        this.statusEntregaFilter = []

        if (this.filtroStatusEntrega.length > 0) {
          const baseStatusEntrega = this.filterStatusEntrega.length > 0 ? this.filterStatusEntrega : this.status

          this.statusEntregaFilter = baseStatusEntrega.filter(status => status.status.toLowerCase().includes(this.filtroStatusEntrega.toLowerCase()))
        }
      },

      toggleClientes () {
        this.$nextTick(() => {
          if (this.likesAllClientes) {
            this.selectClientes = []
          } else {
            const baseClientes =
              this.clientesFilter.length > 0
                ? this.clientesFilter
                : this.filterClientes.length > 0
                  ? this.filterClientes
                  : this.clientes

            this.selectClientes = [...baseClientes]
          }
        })
      },

      filterClientesToggle () {
        this.clientesFilter = []

        if (this.filtroClientes.length > 0) {
          const baseClientes = this.filterClientes.length > 0 ? this.filterClientes : this.clientes

          this.clientesFilter = baseClientes.filter(c => c.cliente.toLowerCase().includes(this.filtroClientes.toLowerCase()))
        }
      },

      filtrarEmpresa () {
        this.filterVendedores = []
        this.filterArea = []
        this.filterRede = []
        this.filterSupervisor = []
        this.filterReceita = []
        this.filterSegmento = []
        this.filterClassificacao = []
        this.filterProduto = []
        this.filterCategoria = []
        this.filterPromotor = []
        this.filterLinhasProducao = []
        this.filterMotorista = []
        this.filterStatusEntrega = []
        this.filterClientes = []

        if (this.select && this.select.length > 0) {
          this.select.forEach(empresa => {
            const vendedores = this.vendedor.filter(vendedor => vendedor.nomeBd === empresa.nome_bd)

            this.filterVendedores.push(...vendedores)

            const areasAux = this.area.filter(a => a.nomeBd === empresa.nome_bd)

            this.filterArea.push(...areasAux)

            const redesAux = this.rede.filter(r => r.nomeBd === empresa.nome_bd)

            this.filterRede.push(...redesAux)

            const supervisorAux = this.supervisor.filter(s => s.nomeBd === empresa.nome_bd)

            this.filterSupervisor.push(...supervisorAux)

            const receitaAux = this.receita.filter(rc => rc.nomeBd === empresa.nome_bd)

            this.filterReceita.push(...receitaAux)

            const segmentoAux = this.segmento.filter(sg => sg.nomeBd === empresa.nome_bd)

            this.filterSegmento.push(...segmentoAux)

            const classificacaoAux = this.classificacao.filter(c => c.nomeBd === empresa.nome_bd)

            this.filterClassificacao.push(...classificacaoAux)

            const produtoAux = this.produto.filter(p => p.nomeBd === empresa.nome_bd)

            this.filterProduto.push(...produtoAux)

            const categoriaAux = this.categoria.filter(ca => ca.nomeBd === empresa.nome_bd)

            this.filterCategoria.push(...categoriaAux)

            const promotorAux = this.promotor.filter(pr => pr.nomeBd === empresa.nome_bd)

            this.filterPromotor.push(...promotorAux)

            const linhasProducaoAux = this.linhasProducao.filter(l => l.nomeBd === empresa.nome_bd)

            this.filterLinhasProducao.push(...linhasProducaoAux)

            const motoristaAux = this.motorista.filter(m => m.nomeBd === empresa.nome_bd)

            this.filterMotorista.push(...motoristaAux)

            const statusEntregaAux = this.status.filter(s => s.nomeBd === empresa.nome_bd)

            this.filterStatusEntrega.push(...statusEntregaAux)

            const clientesAux = this.clientes.filter(c => c.nomeBd === empresa.nome_bd)

            this.filterClientes.push(...clientesAux)
          })
        }

        this.filterVendedores.sort((a, b) => a.vendedor.localeCompare(b.vendedor))

        this.filterArea.sort((a, b) => a.area.localeCompare(b.area))

        this.filterRede.sort((a, b) => a.rede.localeCompare(b.rede))

        this.filterSupervisor.sort((a, b) => a.supervisor.localeCompare(b.supervisor))

        this.filterReceita.sort((a, b) => a.nome.localeCompare(b.nome))

        this.filterSegmento.sort((a, b) => a.segmento.localeCompare(b.segmento))

        this.filterClassificacao.sort((a, b) => a.classificacaoExibicao.localeCompare(b.classificacaoExibicao))

        this.filterProduto.sort((a, b) => a.produto.localeCompare(b.produto))

        this.filterCategoria.sort((a, b) => a.categoria.localeCompare(b.categoria))

        this.filterPromotor.sort((a, b) => a.promotor.localeCompare(b.promotor))

        this.filterLinhasProducao.sort((a, b) => a.linhaProducao.localeCompare(b.linhaProducao))

        this.filterMotorista.sort((a, b) => a.motorista.localeCompare(b.motorista))

        this.filterStatusEntrega.sort((a, b) => a.status.localeCompare(b.status))

        this.filterClientes.sort((a, b) => a.cliente.localeCompare(b.cliente))
      },
    },

  }
</script>

<style scoped>
  .btnFiltroFixado {
    position: fixed;
    top: 65px;
    z-index: 9999;
    transition: right .3s ease;
  }

  .drawerFiltros {
    top: 65px !important;
    height: auto !important;
    max-height: calc(100vh - 65px);
    overflow-y: auto;
    box-shadow: -2px 0 12px rgba(0,0,0,0.25);
  }

  .filters-enter-active {
    animation: enter .5s cubic-bezier(.34,1.56,.64,1);
  }

  .filters-leave-active {
    animation: leave .5s ease;
  }

  @keyframes enter {
    0% {
      opacity: 0;
      transform: scale(.85) translateY(-20px);
    }
    55% {
      opacity: 1;
      transform: scale(1.05) translateY(4px);
    }
    85% {
      transform: scale(0.98) translateY(0px);
    }
    100% {
      transform: scale(1) translateY(0);
    }
  }

  @keyframes leave {
    0% {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
    100% {
      opacity: 0;
      transform: scale(.90) translateY(-15px);
    }
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    .filterMobile{
      display: block
    }

    .filterWeb{
      display: none
    }

    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    .item {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
    }

    #btnRefazer {
      font-size: 10px;
      margin-top: 2rem;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    .filterMobile{
      display: none
    }

    .filterWeb{
      display: block
    }

    #btnRefazer {
      font-size: 12px;
      display: flex;
      max-width: 15vw;
    }

    .container {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .cell {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100px;
    }

    .item {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
      max-width: 840px;
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1800px)
  and (-webkit-min-device-pixel-ratio: 1) {
    .container {
      max-width: 1500px;
    }
  }
</style>

<style lang="sass">
  .filterMobile
    display: none

  .filterWeb
    display: block

  #btnRefazer
    margin: 1.5rem auto

</style>
